import type { MailboxInfo } from 'owa-client-types';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';
import { isTeamsChatPolicyEnabledWithDefault } from 'owa-teams-policies-store/lib/selectors/isTeamsChatPolicyEnabledWithDefault';
import { isCapabilityEnabled } from 'owa-capabilities';
import { chatIntegrationCapability } from 'owa-capabilities-definitions/lib/chatIntegrationCapability';
import {
    getTeamsFeatureAvailabilityLastSession,
    setTeamsFeatureAvailabilityLastSession,
} from './teamsFeatureAvaibility';

let isTeamsFeatureUpdated: boolean = false;

export function isTeamsChatEnabledWithDefault(mailboxInfo: MailboxInfo): boolean {
    const cachedDefault: boolean = getTeamsFeatureAvailabilityLastSession(mailboxInfo);
    const isEnabled: boolean =
        isCapabilityEnabled(chatIntegrationCapability, mailboxInfo) &&
        isBusiness(mailboxInfo) &&
        isTeamsChatPolicyEnabledWithDefault(cachedDefault);

    // If Teams policy is different from the settings on the server, update the setting once.
    if (isEnabled !== cachedDefault && !isTeamsFeatureUpdated) {
        isTeamsFeatureUpdated = true;
        setTeamsFeatureAvailabilityLastSession(isEnabled, mailboxInfo);
    }

    return isEnabled;
}
